var menu = [
  {
    code: "ACCOUNT_MGMT",
    name: "ACCOUNT_MANAGEMENT",
    children: [
      {
        code: "ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE",
        name: "GROUP_ACCOUNT_MAINTAIN",
        path: "/account/maintain",
        icon: "fa-user-circle-o",
      },
      {
        code: "GROUP_ACCOUNT_MAINTENANCE",
        name: "GROUP_ACCOUNT_LIST",
        path: "/account/list",
        icon: "fas fa-list",
      },
    ],
  },
  {
    code: "SYSTEM_DATA_MAINTAIN",
    name: "DATA_MAINTAIN",
    children: [
      {
        code: "SYSTEM_DATA_MAINTAIN_TRANSFER_APPROVER_LIST",
        name: "TRANSFER_APPROVER_LIST",
        path: "/maintain/transfer-approver-list",
        icon: "fa-database",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_PCNEOL_WORKFLOW_MAINTAIN",
        name: "PCNEOL_WORKFLOW_MAINTAIN",
        path: "/maintain/pcneol-workflow-maintain",
        icon: "fa-database",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_MAIN_DATA_MAINTAIN",
        name: "MASTER_DATA_MAINTAIN",
        path: "/maintain/master-data",
        icon: "fa-database",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_APPROVE_AND_FLOW_MAINTAIN",
        name: "QUOTATION_WORKFLOW_MAINTAIN",
        path: "/maintain/workflow",
        icon: "fa-circle-o-notch",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_AP_EXCLUSION_LIST_MAINTAIN",
        name: "SYSTEM_DATA_MAINTAIN_AP_EXCLUSION_LIST_MAINTAIN",
        path: "/vue3/#/pcneol/apply",
        icon: "fa-circle-o-notch",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_AUTHORITY_ROLE_MAINTAIN",
        name: "ROLE_MAINTAIN",
        path: "/maintain/RoleMaintain",
        icon: "fa-university",
      },
      {
        code: "FUNCTION_MAINTAIN",
        name: "FUNCTION_MAINTAIN",
        path: "/maintain/FunctionMaintain",
        icon: "fa-registered",
      },
      {
        code: "USER_MAINTAIN",
        name: "USER_MAINTAIN",
        path: "/maintain/UserMaintain",
        icon: "fa-user-circle",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_ANNOUNCEMENT_MAINTAIN",
        name: "ANNOUNCEMENT_MAINTAIN",
        path: "/maintain/Announcement",
        icon: "fa-pencil-square-o",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_JOB_SCHEDULING",
        name: "JOB_SCHEDULING",
        path: "/maintain/JobSchedule",
        icon: "fa-pencil-square-o",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_CONTACT_PERSON",
        name: "CONTACT_PERSON",
        path: "/maintain/ContactPerson",
        icon: "fa-pencil-square-o",
      },
      {
        code: "SYSTEM_DATA_MAINTAIN_RECEIVING_DOWNLOAD",
        name: "RECEIVING_DOWNLOAD",
        path: "/maintain/receiving-download",
        icon: "fa-pencil-square-o",
      },
    ],
  },
  {
    code: "QUOTATION_MAINTAIN",
    name: "QUOTATION_MAINTAIN",
    children: [
      {
        code: "QUOTATION_MAINTAIN_AVERAGE_PURCHASE_PRICE",
        name: "AVERAGE_PURCHASE_PRICE_MAINTAIN",
        path: "/quotation/average-purchase-price",
        icon: "fa-money",
      },
      {
        code: "QUOTATION_MAINTAIN_QUOTATION_SUPPLIER_MAINTAIN",
        name: "SUPPLIER_MAINTAIN",
        path: "/quotation/supplier-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_QUOTATION_CPC_MAINTAIN",
        name: "CPC_MAINTAIN",
        path: "/quotation/cpc-maintain",
        icon: "fa-handshake-o",
      },
      {
        code: "QUOTATION_MAINTAIN_CPC_HIGH_PRICE_MAINTAIN",
        name: "CPC_HIGH_PRICE_MAINTAIN",
        path: "/quotation/cpc-high-price-maintain",
        icon: "fa-money",
      },
      {
        code: "QUOTATION_MAINTAIN_QUOTATION_SUPERVISOR_MAINTAIN",
        name: "SUPERVISOR_MAINTAIN",
        path: "/quotation/supervisor-maintain",
        icon: "fa-check-square",
      },
      {
        code: "QUOTATION_MAINTAIN_SUPERVISOR_HIGH_PRICE_APPROVE",
        name: "SUPERVISOR_HIPH_PRICE_MAINTAIN",
        path: "/quotation/supervisor-high-price-maintain",
        icon: "fa-money",
      },
      {
        code: "QUOTATION_MAINTAIN_QUOTATION_HISTORY_REPORT",
        name: "QUOTATION_HISTORY_REPORT",
        path: "/quotation/history",
        icon: "fa-history",
      },
      {
        code: "QUOTATION_MAINTAIN_QUOTATION_STATUS_REPORT",
        name: "STATUS_REPORT",
        path: "/quotation/report",
        icon: "fa-clone",
      },
      {
        code: "QUOTATION_MAINTAIN_RM_TYPE_MAINTAIN",
        name: "RM_TYPE_MAINTAIN",
        path: "/quotation/rm-type-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_RM_VENDOR_MAINTAIN",
        name: "RM_VENDOR_MAINTAIN",
        path: "/quotation/rm-vendor-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_RM_DISTRIBUTOR_MAINTAIN",
        name: "RM_DISTRIBUTOR_MAINTAIN",
        path: "/quotation/rm-distributor-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_RM_PART_NO_MAINTAIN",
        name: "RM_PART_NO_MAINTAIN",
        path: "/quotation/rm-part-no-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_STEEL_REFERENCE_PRICE",
        name: "STEEL_REFERENCE_PRICE_MAINTAIN",
        path: "/quotation/steel-reference-price-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_RESIN_REFERENCE_PRICE",
        name: "RESIN_REFERENCE_PRICE_MAINTAIN",
        path: "/quotation/resin-reference-price-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_CCL_MASTER_MAINTAIN",
        name: "CCL_MASTER_MAINTAIN",
        path: "/quotation/ccl-master-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_PCB_MASTER_MAINTAIN",
        name: "PCB_MASTER_MAINTAIN",
        path: "/quotation/pcb-master-maintain",
        icon: "fa-pencil-square-o",
      },
      {
        code: "QUOTATION_MAINTAIN_PCB_GROUP_MAINTAIN",
        name: "PCB_GROUP_MAINTAIN",
        path: "/quotation/pcb-group-maintain",
      icon: "fa-pencil-square-o",
      },
    ],
  },
  {
    code: "CONSIGNMENT_MAINTAIN",
    name: "CONSIGNMENT_MAINTAIN",
    children: [
      {
        code: "CONSIGNMENT_MAINTAIN_SUBCONTRACT_STOCK_QUERY",
        name: "SUBCONTRACT_STOCK_QUERY",
        path: "/vue3/#/consignment/subcontract-stock-query",
        icon: "fa-clone",
      },
      {
        code: "CONSIGNMENT_MAINTAIN_STOCK_QUERY",
        name: "CONSIGNMENT_STOCK_QUERY",
        path: "/vue3/#/consignment/stock-query",
        icon: "fa-clone",
      },
      {
        code: "CONSIGNMENT_MAINTAIN_SUMMARY_REPORT",
        name: "CONSIGNMENT_SUMMARY_REPORT",
        path: "/vue3/#/consignment/summary-report",
        icon: "fa-clone",
      },
      {
        code: "CONSIGNMENT_MAINTAIN_WEEKLY_GI_DETAIL_FOR_THAILAND",
        name: "CONSIGNMENT_WEEKLY_GI_DETAIL_FOR_THAILAND",
        path: "/vue3/#/consignment/weekly-gi-detail-for-thailand",
        icon: "fa-clone",
      },
    ],
  },
  {
    code: "PCNEOL",
    name: "PCNEOL",
    children: [
      {
        code: "PCNEOL_PCNEOLNRND_APPLY",
        name: "PCNEOL_NRND_APPLY",
        path: "/vue3/#/pcneol/apply",
        icon: "fa-clone",
      },
      {
        code: "PCNEOL_PCNEOLNRND_APPROVE",
        name: "PCNEOL_NRND_APPROVE",
        path: "/vue3/#/pcneol/approve",
        icon: "fa-clone",
      },
      {
        code: "PCNEOL_PCNEOLNRND_QUERY",
        name: "PCNEOL_NRND_QUERY",
        path: "/vue3/#/pcneol/query",
        icon: "fa-clone",
      },
    ],
  },
  {
    code: "AP",
    name: "AP_INQUIRY",
    children: [
      {
        code: "AP_INQUIRY_WAITING_CONFIRM_INVOICE",
        name: "AP_INQUIRY_WAITING_CONFIRM_INVOICE",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_CONFIRMED_INVOICE_QUERY",
        name: "AP_INQUIRY_CONFIRMED_INVOICE_QUERY",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT_SUMMARY_QUERY",
        name: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT_SUMMARY_QUERY",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT",
        name: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_DISPLAY_VENDOR_INVOICE",
        name: "AP_INQUIRY_DISPLAY_VENDOR_INVOICE",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_INVOICE_TO_BE_DUE_FOR_PAYMENT",
        name: "AP_INQUIRY_INVOICE_TO_BE_DUE_FOR_PAYMENT",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_LIST_OF_PAYMENT_BLOCK",
        name: "AP_INQUIRY_LIST_OF_PAYMENT_BLOCK",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_ERS_REPORT_QUERY",
        name: "AP_INQUIRY_ERS_REPORT_QUERY",
        icon: "fa-clone",
      },
      {
        code: "AP_INQUIRY_GOOD_RECEIVED_AND_NOT_POST_TO_AP",
        name: "AP_INQUIRY_GOOD_RECEIVED_AND_NOT_POST_TO_AP",
        icon: "fa-clone",
      },
    ],
  },
]

export {menu}